import type { EventDetailType } from '../types'

const JOURNEY_NAVIGATION_EVENT = 'JourneyNavigationEvent'
const JOURNEY_LOADING_EVENT = 'JourneyLoadingEvent'
const JOURNEY_EXIT_EVENT = 'JourneyExitEvent'

function on(eventType: string, listener: EventListenerOrEventListenerObject) {
  window.addEventListener(eventType, listener)
}

function off(eventType: string, listener: EventListenerOrEventListenerObject) {
  window.removeEventListener(eventType, listener)
}

function trigger(eventType: string, data: unknown) {
  const event = new CustomEvent(eventType, { detail: data })

  window.dispatchEvent(event)
}

const dispatchLoadingEvent = (isLoading: boolean) => {
  const event = new CustomEvent<EventDetailType>(JOURNEY_LOADING_EVENT, {
    detail: {
      payload: {
        value: isLoading
      }
    }
  })

  document.dispatchEvent(event)
}

const dispatchExitEvent = () => {
  const event = new CustomEvent<EventDetailType>(JOURNEY_EXIT_EVENT)

  document.dispatchEvent(event)
}

export {
  on,
  off,
  trigger,
  dispatchLoadingEvent,
  dispatchExitEvent,
  JOURNEY_NAVIGATION_EVENT,
  JOURNEY_LOADING_EVENT,
  JOURNEY_EXIT_EVENT
}
